module.exports = __webpack_public_path__ + "img/ubercart8.b6feab21.png";